const checkFeedFilterType = (type) => type !== 'companies';

export default checkFeedFilterType;
